import React, { createContext, useContext, useState, useEffect } from "react";

const ThemeContext = createContext();

export const useCustomTheme = () => useContext(ThemeContext);

const SYSTEM_QUERY = "(prefers-color-scheme: dark)";

const resolveTheme = (selected) => {
  if (selected === "system") {
    return window.matchMedia(SYSTEM_QUERY).matches ? "dark" : "light";
  }
  return selected;
};

export const ThemeProvider = ({ children }) => {
  const [selectedTheme, setSelectedTheme] = useState(() => {
    return localStorage.getItem("userSelectedTheme") || "system";
  });

  const [theme, setTheme] = useState(() => resolveTheme(selectedTheme));

  useEffect(() => {
    localStorage.setItem("userSelectedTheme", selectedTheme);
    setTheme(resolveTheme(selectedTheme));
  }, [selectedTheme]);

  useEffect(() => {
    if (selectedTheme !== "system") return;

    const mediaQuery = window.matchMedia(SYSTEM_QUERY);
    const handleChange = (event) => setTheme(event.matches ? "dark" : "light");
    mediaQuery.addEventListener("change", handleChange);
    return () => mediaQuery.removeEventListener("change", handleChange);
  }, [selectedTheme]);

  const value = { theme, selectedTheme, setSelectedTheme };

  return <ThemeContext.Provider value={value}>{children}</ThemeContext.Provider>;
};
